import AddTaskFromJiraModal from '@/modules/corporate/modules/integrations/providers/Jira/components/AddTaskFromJiraModal';
import AutoSyncFromJiraModal from '@/modules/corporate/modules/integrations/providers/Jira/components/AutoSyncFromJiraModal';
import AddTasksModal from '@/modules/tasks/components/AddTasksModal';
import { ProviderType, RelatedEntityTypeEnum } from '@/types/schema';

import { InViewActionDialog } from '../../types';

interface ActionDialogProps {
  inViewDialog?: InViewActionDialog;
  provider?: ProviderType;
  entityId?: string;
  onClose: () => void;
  onSubmit: (props?: { refetchData?: boolean }) => void;
  entity?: RelatedEntityTypeEnum;
  fileId?: string | null;
}

function ActionDialogs(props: ActionDialogProps) {
  const { inViewDialog, onClose, provider, entityId, entity, fileId, onSubmit } = props;

  if (!inViewDialog) {
    return null;
  }

  if (inViewDialog === InViewActionDialog.AddTaskFromJira && provider) {
    return (
      <AddTaskFromJiraModal
        entity={entity}
        entityId={entityId}
        fileId={fileId}
        provider={provider}
        onClose={onClose}
        onSubmit={() => onSubmit({ refetchData: true })}
      />
    );
  }

  if (inViewDialog === InViewActionDialog.AutoSyncFromJira && provider) {
    return (
      <AutoSyncFromJiraModal
        entity={entity}
        entityId={entityId}
        fileId={fileId}
        provider={provider}
        onClose={onClose}
        onSubmit={() => onSubmit({ refetchData: true })}
      />
    );
  }

  if (inViewDialog === InViewActionDialog.AddTasks) {
    return (
      <AddTasksModal
        entity={entity}
        entityId={entityId}
        onClose={onClose}
        onSubmit={() => onSubmit({ refetchData: true })}
      />
    );
  }

  return null;
}

export default ActionDialogs;
